module.exports = __webpack_public_path__ + "static/genuss-desktop-43013b8412de32d8390b7f86bb333fc8.jpg";